// src/app/telemetry-bootstrap.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TelemetryConfigService } from './telemetry-config.service';
import { ApplicationInsightsService } from './application-insights.service';
import { initRum } from './rum-init';

@Injectable({ providedIn: 'root' })
export class TelemetryBootstrapService {
  constructor(
    private cfg: TelemetryConfigService,
    private router: Router,
    private aiSvc: ApplicationInsightsService
  ) {}

  init(): void {
    const provider = this.cfg.config.provider;
    if (provider === 'azure') {
      this.aiSvc.init(this.router, this.cfg.config.azure);
    } else if (provider === 'aws') {
      initRum(this.cfg.config.aws);
    }
  }
}